(function () {
  const config = window.__productInventory;

  if (!config || !config.variantId || !config.shopDomain || !config.storefrontToken) {
    console.warn('[store-availability] 必要な設定が見つかりません。');
    return;
  }

  const { shopDomain, storefrontToken } = config;

  const QUERY = `
    query getVariantInventory($id: ID!) {
      node(id: $id) {
        ... on ProductVariant {
          quantityAvailable
          storeAvailability(first: 20) {
            edges {
              node {
                available
                quantityAvailable
                location {
                  name
                }
              }
            }
          }
        }
      }
    }
  `;

  async function fetchInventory(variantId) {
    const gid = `gid://shopify/ProductVariant/${variantId}`;

    try {
      const res = await fetch(
        `https://${shopDomain}/api/2024-10/graphql.json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": storefrontToken
          },
          body: JSON.stringify({
            query: QUERY,
            variables: { id: gid }
          })
        }
      );

      if (!res.ok) {
        console.error('[store-availability] APIエラー:', res.status);
        return null;
      }

      const json = await res.json();

      if (json.errors) {
        console.error('[store-availability] GraphQLエラー:', json.errors);
        return null;
      }

      return json.data?.node ?? null;

    } catch (err) {
      console.error('[store-availability] fetchエラー:', err);
      return null;
    }
  }

  /**
   * ロケーション名をキーに、在庫数のマップを生成
   */
  function buildQuantityMap(variant) {
    const map = {};
    if (!variant) return map;

    variant.storeAvailability.edges.forEach(({ node }) => {
      map[node.location.name] = node.quantityAvailable;
    });

    return map;
  }

  /**
   * 在庫数が0以下のロケーションを非表示にする
   */
  function filterLocations(quantityMap) {
    const locationEls = document.querySelectorAll('.location[data-location-name]');

    locationEls.forEach(function (el) {
      const name = el.getAttribute('data-location-name');

      // quantityMapに存在しない（APIで取得できなかった）場合はそのまま表示
      if (!(name in quantityMap)) return;

      if (quantityMap[name] <= 0) {
        el.style.display = 'none';
      } else {
        el.style.display = '';
      }
    });
  }

  function applyInventory(variantId) {
    fetchInventory(variantId).then(function (variant) {
      const quantityMap = buildQuantityMap(variant);
      filterLocations(quantityMap);
    });
  }

  // 初回ロード
  applyInventory(config.variantId);

  // バリアント切り替え対応
  [document, document.querySelector('form[action="/cart/add"]')]
    .filter(Boolean)
    .forEach(function (target) {
      target.addEventListener("variant:changed", function (e) {
        if (!e.detail || !e.detail.variant || !e.detail.variant.id) return;
        applyInventory(e.detail.variant.id);
      });
    });

})();
